import { render, staticRenderFns } from "./MtSuppliersForm.vue?vue&type=template&id=487bcd13&"
import script from "./MtSuppliersForm.vue?vue&type=script&lang=js&"
export * from "./MtSuppliersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports